import {SET_DATA_FINISH_LOT_MODAL} from "../../types";

export function setParamsFinishLotModal(data) {
    return (dispatch) => {
        dispatch({type: SET_DATA_FINISH_LOT_MODAL, payload: data});
    }
}